import { Box, Grid, Fade, Slide } from "@mui/material"
import { FormLogin } from "../../components";
import { useState, useEffect } from "react";

const LoginScreen = () => {
    const [showContent, setShowContent] = useState(false);
    const [showLogo, setShowLogo] = useState(false);

    useEffect(() => {
        // Activar animaciones secuencialmente
        setShowContent(true);
        const logoTimer = setTimeout(() => {
            setShowLogo(true);
        }, 300);

        return () => clearTimeout(logoTimer);
    }, []);

    return (
        <Grid container xs={12} sx={{ width: '100%', height: '100vh' }}>
            <Slide direction="right" in={showContent} timeout={800}>
                <Grid item xs={12} md={6} className='bg-white'>
                    <Box 
                        sx={{
                            display: 'flex', 
                            justifyContent: 'center', 
                            alignItems: 'center',
                            width: '100%', 
                            height: '100vh',
                            background: 'linear-gradient(135deg, #ffffff 0%, #fafbfc 100%)',
                            position: 'relative',
                            overflow: 'hidden',
                            '&::before': {
                                content: '""',
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                background: 'radial-gradient(circle at 20% 20%, rgba(99, 102, 241, 0.05) 0%, transparent 50%)',
                                animation: 'float 6s ease-in-out infinite',
                            },
                            '@keyframes float': {
                                '0%, 100%': { 
                                    transform: 'translate(0, 0) scale(1)',
                                    opacity: 0.5 
                                },
                                '50%': { 
                                    transform: 'translate(-10px, -10px) scale(1.1)',
                                    opacity: 0.8 
                                }
                            }
                        }}
                    >
                        <FormLogin />
                    </Box>
                </Grid>
            </Slide>
            <Fade in={showContent} timeout={1000}>
                <Grid item xs={0} md={6}>
                    <Box
                        sx={{
                            backgroundImage: 'url(/img/logoFondo.png)',
                            width: '100%',
                            height: '99vh',
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            position: 'relative',
                            display: 'inline-block',
                            overflow: 'hidden',
                            backgroundPosition: 'center',
                            '&::before': {
                                content: '""',
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                background: 'linear-gradient(135deg, rgba(3, 100, 255, 0.1) 0%, rgba(2, 71, 181, 0.2) 100%)',
                                animation: 'pulse 4s ease-in-out infinite',
                            },
                            '@keyframes pulse': {
                                '0%, 100%': { 
                                    opacity: 0.3 
                                },
                                '50%': { 
                                    opacity: 0.1 
                                }
                            }
                        }}
                    >
                        <Slide direction="up" in={showLogo} timeout={1200}>
                            <img
                                src="/img/Zeta-black.png"
                                style={{
                                    position: 'absolute', 
                                    top: '37%',
                                    left: '33%', 
                                    transform: 'scale(0.8)',
                                    filter: 'drop-shadow(0 4px 20px rgba(0, 0, 0, 0.1))',
                                    animation: 'logoFloat 3s ease-in-out infinite',
                                }}
                            />
                        </Slide>
                    </Box>
                </Grid>
            </Fade>

            {/* Keyframes para el logo */}
            <style jsx>{`
                @keyframes logoFloat {
                    0%, 100% { 
                        transform: scale(0.8) translateY(0px);
                    }
                    50% { 
                        transform: scale(0.82) translateY(-5px);
                    }
                }
            `}</style>
        </Grid>
    )
}

export default LoginScreen